export * from "./hotel-reserve-empty-result";
